import axiosInstance from "../../api/axiosInstance";

let getSpaceStatusFile = (user) => {
    return new Promise((resolve, reject) => { 
        let uri = process.env.REACT_APP_API + "/espacios/estado-carga";
        axiosInstance.get(uri).then(response=> {
            resolve(response);
        }).catch(error => {
            console.log(error);
            resolve(error.response);
        });
    })
}

let getMeasuresStatusFile = (user) => {
    return new Promise((resolve, reject) => { 
        let uri = process.env.REACT_APP_API + "/medidas/medidas/estado-carga";
        axiosInstance.get(uri).then(response=> {
            resolve(response);
        }).catch(error => {
            console.log(error);
            resolve(error.response);
        });
    })
}

let getReports = (user) => {
    return new Promise((resolve, reject) => { 
        let uri = process.env.REACT_APP_API + "/informes/" + user?.profile + "/" + user?.locale;
        axiosInstance.get(uri).then(response=> {
            resolve(response);
        }).catch(error => {
            console.log(error);
            resolve(error.response);
        });
    })
}

export {
    getSpaceStatusFile,
    getMeasuresStatusFile,
    getReports
}